import { render, staticRenderFns } from "./commodity-detail.vue?vue&type=template&id=75834770&scoped=true"
import script from "./commodity-detail.vue?vue&type=script&lang=js"
export * from "./commodity-detail.vue?vue&type=script&lang=js"
import style0 from "./commodity-detail.vue?vue&type=style&index=0&id=75834770&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75834770",
  null
  
)

export default component.exports